/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Account API
 * This API is for managing Accounts, Organizations and Workspaces.
 * OpenAPI spec version: 1.4.2
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateOrganizationDto,
  OrganizationsControllerCreate201,
  OrganizationsControllerCreate400,
  OrganizationsControllerDelete404,
  OrganizationsControllerGet200,
  OrganizationsControllerGet404,
  OrganizationsControllerGetAll200,
  OrganizationsControllerGetAllParams,
  OrganizationsControllerUpdate200,
  OrganizationsControllerUpdate400,
  OrganizationsControllerUpdate404,
  UpdateOrganizationDto
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get all organizations paginated
 * @summary Get all organizations
 */
export type organizationsControllerGetAllResponse200 = {
  data: OrganizationsControllerGetAll200
  status: 200
}

export type organizationsControllerGetAllResponseSuccess = (organizationsControllerGetAllResponse200) & {
  headers: Headers;
};
;

export type organizationsControllerGetAllResponse = (organizationsControllerGetAllResponseSuccess)

export const getOrganizationsControllerGetAllUrl = (accountId: string,
    params?: OrganizationsControllerGetAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/accounts/${accountId}/organizations?${stringifiedParams}` : `/accounts/${accountId}/organizations`
}

export const organizationsControllerGetAll = async (accountId: string,
    params?: OrganizationsControllerGetAllParams, options?: RequestInit): Promise<organizationsControllerGetAllResponse> => {
  
  return customFetch<organizationsControllerGetAllResponse>(getOrganizationsControllerGetAllUrl(accountId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getOrganizationsControllerGetAllQueryKey = (accountId: string,
    params?: OrganizationsControllerGetAllParams,) => {
    return [
    `/accounts/${accountId}/organizations`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getOrganizationsControllerGetAllQueryOptions = <TData = Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError = ErrorType<unknown>>(accountId: string,
    params?: OrganizationsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationsControllerGetAllQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationsControllerGetAll>>> = ({ signal }) => organizationsControllerGetAll(accountId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationsControllerGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof organizationsControllerGetAll>>>
export type OrganizationsControllerGetAllQueryError = ErrorType<unknown>


export function useOrganizationsControllerGetAll<TData = Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params: undefined |  OrganizationsControllerGetAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerGetAll>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerGetAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationsControllerGetAll<TData = Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: OrganizationsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerGetAll>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerGetAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationsControllerGetAll<TData = Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: OrganizationsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all organizations
 */

export function useOrganizationsControllerGetAll<TData = Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: OrganizationsControllerGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGetAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationsControllerGetAllQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Create a new organization with the provided data
 * @summary Create a new organization
 */
export type organizationsControllerCreateResponse201 = {
  data: OrganizationsControllerCreate201
  status: 201
}

export type organizationsControllerCreateResponse400 = {
  data: OrganizationsControllerCreate400
  status: 400
}

export type organizationsControllerCreateResponseSuccess = (organizationsControllerCreateResponse201) & {
  headers: Headers;
};
export type organizationsControllerCreateResponseError = (organizationsControllerCreateResponse400) & {
  headers: Headers;
};

export type organizationsControllerCreateResponse = (organizationsControllerCreateResponseSuccess | organizationsControllerCreateResponseError)

export const getOrganizationsControllerCreateUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}/organizations`
}

export const organizationsControllerCreate = async (accountId: string,
    createOrganizationDto: CreateOrganizationDto, options?: RequestInit): Promise<organizationsControllerCreateResponse> => {
  
  return customFetch<organizationsControllerCreateResponse>(getOrganizationsControllerCreateUrl(accountId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrganizationDto,)
  }
);}
  



export const getOrganizationsControllerCreateMutationOptions = <TError = ErrorType<OrganizationsControllerCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerCreate>>, TError,{accountId: string;data: CreateOrganizationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerCreate>>, TError,{accountId: string;data: CreateOrganizationDto}, TContext> => {

const mutationKey = ['organizationsControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsControllerCreate>>, {accountId: string;data: CreateOrganizationDto}> = (props) => {
          const {accountId,data} = props ?? {};

          return  organizationsControllerCreate(accountId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsControllerCreate>>>
    export type OrganizationsControllerCreateMutationBody = CreateOrganizationDto
    export type OrganizationsControllerCreateMutationError = ErrorType<OrganizationsControllerCreate400>

    /**
 * @summary Create a new organization
 */
export const useOrganizationsControllerCreate = <TError = ErrorType<OrganizationsControllerCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerCreate>>, TError,{accountId: string;data: CreateOrganizationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationsControllerCreate>>,
        TError,
        {accountId: string;data: CreateOrganizationDto},
        TContext
      > => {
      return useMutation(getOrganizationsControllerCreateMutationOptions(options), queryClient);
    }
    /**
 * Get an organization by id
 * @summary Get an organization by id
 */
export type organizationsControllerGetResponse200 = {
  data: OrganizationsControllerGet200
  status: 200
}

export type organizationsControllerGetResponse404 = {
  data: OrganizationsControllerGet404
  status: 404
}

export type organizationsControllerGetResponseSuccess = (organizationsControllerGetResponse200) & {
  headers: Headers;
};
export type organizationsControllerGetResponseError = (organizationsControllerGetResponse404) & {
  headers: Headers;
};

export type organizationsControllerGetResponse = (organizationsControllerGetResponseSuccess | organizationsControllerGetResponseError)

export const getOrganizationsControllerGetUrl = (accountId: string,
    organizationId: string,) => {


  

  return `/accounts/${accountId}/organizations/${organizationId}`
}

export const organizationsControllerGet = async (accountId: string,
    organizationId: string, options?: RequestInit): Promise<organizationsControllerGetResponse> => {
  
  return customFetch<organizationsControllerGetResponse>(getOrganizationsControllerGetUrl(accountId,organizationId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getOrganizationsControllerGetQueryKey = (accountId: string,
    organizationId: string,) => {
    return [
    `/accounts/${accountId}/organizations/${organizationId}`
    ] as const;
    }

    
export const getOrganizationsControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof organizationsControllerGet>>, TError = ErrorType<OrganizationsControllerGet404>>(accountId: string,
    organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationsControllerGetQueryKey(accountId,organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationsControllerGet>>> = ({ signal }) => organizationsControllerGet(accountId,organizationId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId && organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationsControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof organizationsControllerGet>>>
export type OrganizationsControllerGetQueryError = ErrorType<OrganizationsControllerGet404>


export function useOrganizationsControllerGet<TData = Awaited<ReturnType<typeof organizationsControllerGet>>, TError = ErrorType<OrganizationsControllerGet404>>(
 accountId: string,
    organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationsControllerGet<TData = Awaited<ReturnType<typeof organizationsControllerGet>>, TError = ErrorType<OrganizationsControllerGet404>>(
 accountId: string,
    organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof organizationsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationsControllerGet<TData = Awaited<ReturnType<typeof organizationsControllerGet>>, TError = ErrorType<OrganizationsControllerGet404>>(
 accountId: string,
    organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an organization by id
 */

export function useOrganizationsControllerGet<TData = Awaited<ReturnType<typeof organizationsControllerGet>>, TError = ErrorType<OrganizationsControllerGet404>>(
 accountId: string,
    organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationsControllerGetQueryOptions(accountId,organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Update an existing organization with the provided data
 * @summary Update an organization
 */
export type organizationsControllerUpdateResponse200 = {
  data: OrganizationsControllerUpdate200
  status: 200
}

export type organizationsControllerUpdateResponse400 = {
  data: OrganizationsControllerUpdate400
  status: 400
}

export type organizationsControllerUpdateResponse404 = {
  data: OrganizationsControllerUpdate404
  status: 404
}

export type organizationsControllerUpdateResponseSuccess = (organizationsControllerUpdateResponse200) & {
  headers: Headers;
};
export type organizationsControllerUpdateResponseError = (organizationsControllerUpdateResponse400 | organizationsControllerUpdateResponse404) & {
  headers: Headers;
};

export type organizationsControllerUpdateResponse = (organizationsControllerUpdateResponseSuccess | organizationsControllerUpdateResponseError)

export const getOrganizationsControllerUpdateUrl = (accountId: string,
    organizationId: string,) => {


  

  return `/accounts/${accountId}/organizations/${organizationId}`
}

export const organizationsControllerUpdate = async (accountId: string,
    organizationId: string,
    updateOrganizationDto: UpdateOrganizationDto, options?: RequestInit): Promise<organizationsControllerUpdateResponse> => {
  
  return customFetch<organizationsControllerUpdateResponse>(getOrganizationsControllerUpdateUrl(accountId,organizationId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationDto,)
  }
);}
  



export const getOrganizationsControllerUpdateMutationOptions = <TError = ErrorType<OrganizationsControllerUpdate400 | OrganizationsControllerUpdate404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerUpdate>>, TError,{accountId: string;organizationId: string;data: UpdateOrganizationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerUpdate>>, TError,{accountId: string;organizationId: string;data: UpdateOrganizationDto}, TContext> => {

const mutationKey = ['organizationsControllerUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsControllerUpdate>>, {accountId: string;organizationId: string;data: UpdateOrganizationDto}> = (props) => {
          const {accountId,organizationId,data} = props ?? {};

          return  organizationsControllerUpdate(accountId,organizationId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsControllerUpdate>>>
    export type OrganizationsControllerUpdateMutationBody = UpdateOrganizationDto
    export type OrganizationsControllerUpdateMutationError = ErrorType<OrganizationsControllerUpdate400 | OrganizationsControllerUpdate404>

    /**
 * @summary Update an organization
 */
export const useOrganizationsControllerUpdate = <TError = ErrorType<OrganizationsControllerUpdate400 | OrganizationsControllerUpdate404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerUpdate>>, TError,{accountId: string;organizationId: string;data: UpdateOrganizationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationsControllerUpdate>>,
        TError,
        {accountId: string;organizationId: string;data: UpdateOrganizationDto},
        TContext
      > => {
      return useMutation(getOrganizationsControllerUpdateMutationOptions(options), queryClient);
    }
    /**
 * Soft delete an organization by id
 * @summary Delete an organization
 */
export type organizationsControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type organizationsControllerDeleteResponse404 = {
  data: OrganizationsControllerDelete404
  status: 404
}

export type organizationsControllerDeleteResponseSuccess = (organizationsControllerDeleteResponse204) & {
  headers: Headers;
};
export type organizationsControllerDeleteResponseError = (organizationsControllerDeleteResponse404) & {
  headers: Headers;
};

export type organizationsControllerDeleteResponse = (organizationsControllerDeleteResponseSuccess | organizationsControllerDeleteResponseError)

export const getOrganizationsControllerDeleteUrl = (accountId: string,
    organizationId: string,) => {


  

  return `/accounts/${accountId}/organizations/${organizationId}`
}

export const organizationsControllerDelete = async (accountId: string,
    organizationId: string, options?: RequestInit): Promise<organizationsControllerDeleteResponse> => {
  
  return customFetch<organizationsControllerDeleteResponse>(getOrganizationsControllerDeleteUrl(accountId,organizationId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getOrganizationsControllerDeleteMutationOptions = <TError = ErrorType<OrganizationsControllerDelete404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerDelete>>, TError,{accountId: string;organizationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerDelete>>, TError,{accountId: string;organizationId: string}, TContext> => {

const mutationKey = ['organizationsControllerDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsControllerDelete>>, {accountId: string;organizationId: string}> = (props) => {
          const {accountId,organizationId} = props ?? {};

          return  organizationsControllerDelete(accountId,organizationId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsControllerDelete>>>
    
    export type OrganizationsControllerDeleteMutationError = ErrorType<OrganizationsControllerDelete404>

    /**
 * @summary Delete an organization
 */
export const useOrganizationsControllerDelete = <TError = ErrorType<OrganizationsControllerDelete404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerDelete>>, TError,{accountId: string;organizationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationsControllerDelete>>,
        TError,
        {accountId: string;organizationId: string},
        TContext
      > => {
      return useMutation(getOrganizationsControllerDeleteMutationOptions(options), queryClient);
    }
    export type organizationsControllerHardDeleteResponse204 = {
  data: void
  status: 204
}

export type organizationsControllerHardDeleteResponseSuccess = (organizationsControllerHardDeleteResponse204) & {
  headers: Headers;
};
;

export type organizationsControllerHardDeleteResponse = (organizationsControllerHardDeleteResponseSuccess)

export const getOrganizationsControllerHardDeleteUrl = (accountId: string,
    organizationId: string,) => {


  

  return `/accounts/${accountId}/organizations/${organizationId}/hard`
}

export const organizationsControllerHardDelete = async (accountId: string,
    organizationId: string, options?: RequestInit): Promise<organizationsControllerHardDeleteResponse> => {
  
  return customFetch<organizationsControllerHardDeleteResponse>(getOrganizationsControllerHardDeleteUrl(accountId,organizationId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getOrganizationsControllerHardDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerHardDelete>>, TError,{accountId: string;organizationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerHardDelete>>, TError,{accountId: string;organizationId: string}, TContext> => {

const mutationKey = ['organizationsControllerHardDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationsControllerHardDelete>>, {accountId: string;organizationId: string}> = (props) => {
          const {accountId,organizationId} = props ?? {};

          return  organizationsControllerHardDelete(accountId,organizationId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsControllerHardDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof organizationsControllerHardDelete>>>
    
    export type OrganizationsControllerHardDeleteMutationError = ErrorType<unknown>

    export const useOrganizationsControllerHardDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationsControllerHardDelete>>, TError,{accountId: string;organizationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationsControllerHardDelete>>,
        TError,
        {accountId: string;organizationId: string},
        TContext
      > => {
      return useMutation(getOrganizationsControllerHardDeleteMutationOptions(options), queryClient);
    }
    